export default (params) => ({
  trigger: {
    name: 'postal_code_checker.open_postal_code_checker',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'sub_header',
          'order_block',
          'product_card',
          'category_navigation',
        ],
      },
    },
    event: {
      name: 'open_panel',
    },
    nonInt: false,
  },
});
